<section
    data-testid="block-duo-media"
    [hAnimateOnScroll]="{
        animate: blockDuoMedia.hasAnimation,
        threshold: 0.2,
    }"
    class="block-duo-media">
    @if (blockDuoMedia.mediaLeft) {
        <div class="media left">
            <h-media-cta [media]="blockDuoMedia.mediaLeft" [preloadPoster]="shouldPreloadMedia"></h-media-cta>
        </div>
    }
    @if (blockDuoMedia.mediaRight) {
        <div class="media right">
            <h-media-cta [media]="blockDuoMedia.mediaRight" [preloadPoster]="shouldPreloadMedia"></h-media-cta>
        </div>
    }
</section>
